module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "page_normal--num_4--seq_4"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_normal--num_4--seq_4"
    }
  }, [_c('div', {
    staticClass: "title-block-book"
  }, [_c('h1', [_vm._v("MARRYING THE MISTRESS ")]), _vm._v(" "), _c('p', {
    staticClass: "title-author"
  }, [_vm._v("Juliet Landon ")]), _vm._v(" "), _c('div', {
    staticClass: "imprint"
  }, [_c('p', {
    staticClass: "title-publisher"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "new_mab02_logo.jpg",
      "title": ""
    }
  })])])])])]), _c('a', {
    attrs: {
      "id": "page_normal--num_4--seq_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcb358ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781408908150_booktitlepage.vue
// module id = 63
// module chunks = 0